import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { FeatureFlagProvider } from './contexts/FeatureFlagContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { init } from './lib/analytics';

init();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <FeatureFlagProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </FeatureFlagProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// Register the Web Push service worker. We skip dev to avoid interfering with HMR
// and skip browsers that lack support entirely.
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch((error) => {
      // eslint-disable-next-line no-console
      console.warn('SW registration failed:', error);
    });
  });
}
